export default "__VITE_ASSET__CJpC1VEn__"